import React, { useState, useEffect } from "react";
import GaugeCard from "./GaugeCard";
import _NewapplicationService from "../../modules/NewapplicationService";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message, Tooltip } from "antd";
import _commonService from "../../modules/commonService";
import { BarChart, Bar, XAxis, YAxis, LabelList, Cell } from 'recharts';
import "./Dashboard.scss";
import { QuestionCircleOutlined, FileTextOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

// export const CBR_RANGES = [
//   { limit: 20, color: "#7F1D1D" },  // Very Low
//   { limit: 40, color: "#B91C1C" },  // Low
//   { limit: 60, color: "#3ef797" },  // Medium
//   { limit: 80, color: "#00c046" },  // Good
//   { limit: 100, color: "#00ff5e" }, // High
// ];

// export const TDSR_RANGES = [
//   { value: 20, color: "#22C55E" },  // Low debt (Excellent)
//   { value: 65, color: "#EAB308" },  // Moderate debt
//   { value: 100, color: "#EF4444" }, // High debt (Risk)
// ];

// export const LEVERAGE_RANGES = [
//   { value: 0.75, color: "#22C55E" },  // Low (Healthy)
//   { value: 1.75, color: "#EAB308" },  // Moderate
//   { value: 3, color: "#EF4444" },     // High (Risk)
// ];

export const CBR_RANGES = [
  { value: 579, color: "#2A4A53" },  
  { value: 669, color: "#427471" },  
  { value: 739, color: "#9FC7FF" },  
  { value: 799, color: "#00E3C4" },  
  { value: 900, color: "#16A34A" },  
];

export const TDSR_RANGES = [
  { value: 20, color: "#16A34A" },   
  { value: 65, color: "#00E3C4" },   
  { value: 100, color: "#2A4A53" },  
];

export const LEVERAGE_RANGES = [
  { value: 0.75, color: "#16A34A" },  
  { value: 1.75, color: "#00E3C4" },  
  { value: 3, color: "#2A4A53" },     
];

const AssessmentTab = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const [assesmentInfo, setAssesmentInfo] = useState({});

  useEffect(() => {
    if (activeKey && activeKey == "2") {
      getApplicantAssesmentInfoByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
      getApplicationStatusByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
    }
  }, [activeKey]);

  const getApplicationStatusByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicationStatusByApplicationId(Number(applicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("isAllStepsCompleted", JSON.stringify(resObj?.applicationScreenStatus?.IsAllStepsCompleted ?? false));
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getApplicantAssesmentInfoByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantAssesmentInfoByApplicationId(Number(applicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("ApplicantName", resObj.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");

        setAssesmentInfo(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // console.log("assesmentInfo", assesmentInfo);

  // const safeLimitValue = assesmentInfo && assesmentInfo.SafeLimit;
  const currentValue = assesmentInfo && assesmentInfo.Current;
  const proFormaValue = assesmentInfo && assesmentInfo.PostLoan;

  // Extract numeric part before %
  // const safeLimitPercent = parseFloat(safeLimitValue && safeLimitValue.split('%')[0]);
  const currentPercent = parseFloat(currentValue && currentValue.split('%')[0]);
  const proFormaPercent = parseFloat(proFormaValue && proFormaValue.split('%')[0]);

  // Calculate difference
  // const differencePercent = safeLimitPercent - currentPercent;

  const barData = [
    {
      name: 'Current',
      value: currentPercent,
      // safeLimitAmount: 400000,
      color: '#93C5FD',
    },
    {
      name: 'Pro-Forma',
      // safeLimit: safeLimitPercent,
      proForma: proFormaPercent,
      // currentAmount: 105000,
      // postLoanAmount: 500000,
    }
  ];

  // const CustomTooltip = ({ active, payload }) => {
  //   if (!active || !payload) return null;
  //   const item = payload[0]?.payload;
  //   return (
  //     <div style={{ background: 'white', border: '1px solid #ccc', padding: 10 }}>
  //       <p><strong>{item.name}</strong></p>
  //       {item.value && <p>Safe Limit: 30%, ${item.safeLimitAmount && item.safeLimitAmount.toLocaleString()}</p>}
  //       {item.safeLimit && (
  //         <>
  //           <p>Current: 25%, ${item.currentAmount && item.currentAmount.toLocaleString()}</p>
  //           <p>Pro-Forma: 45%, ${item.postLoanAmount && item.postLoanAmount.toLocaleString()}</p>
  //         </>
  //       )}
  //     </div>
  //   );
  // };


  return (
    <Spin spinning={loading}>

      {/* Key Metrics (CBR Score / TDSR % / Leverage) hidden per request */}
      <Row gutter={16} className="iconFont chartbox-main-wrapper threebox mb15">
        <Col
          xs={24} sm={12} md={8} lg={8} xl={8}

          className="gutter-row chartbox1"
        >
          <>
            {/* <GaugeCard label="CBR Score" value={Number(assesmentInfo && assesmentInfo.CBRScore)} min={300} max={850} description={assesmentInfo && assesmentInfo.CBRScoreStaus} /> */}
            <GaugeCard
              label="CBR Score"
              value={Number(assesmentInfo && assesmentInfo.CBRScore)}
              minValue={500}
              maxValue={900}
              ranges={CBR_RANGES}
              // threshold={assesmentInfo && assesmentInfo.SponserCBR}
              higherIsBetter
              description={assesmentInfo && assesmentInfo.CBRScoreStaus}
            />
          </>
        </Col>
        <Col
          xs={24} sm={12} md={8} lg={8} xl={8}
          className="gutter-row chartbox1"
        >
          <>
            {/* <GaugeCard label="TDSR %" value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : "N/A"} min={0} max={100} unit=" %" description={assesmentInfo && assesmentInfo.TDSRStatus} /> */}
            <GaugeCard
              label="TDSR %"
              value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : 0}
              minValue={0}
              maxValue={100}
              unit="%"
              ranges={TDSR_RANGES}
              // threshold={assesmentInfo && assesmentInfo.SponserTDSR}
              description={assesmentInfo && assesmentInfo.TDSRStatus}
            />

          </>
        </Col>
        <Col
          xs={24} sm={12} md={8} lg={8} xl={8}
          className="gutter-row chartbox1"
        >
          <>
            {/* <GaugeCard label="Leverage" value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : "N/A"} min={0} max={2} description={assesmentInfo && assesmentInfo.LevridgeStatus} /> */}
            <GaugeCard
              label="Leverage"
              value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : 0 }
              minValue={0}
              maxValue={3}
              ranges={LEVERAGE_RANGES}
              // threshold={assesmentInfo && assesmentInfo.SponserLevrage}
              description={assesmentInfo && assesmentInfo.LevridgeStatus}
            />
          </>
        </Col>
      </Row>
     


      <Row gutter={16} className="rowAlignNew iconFont" align="stretch">
        <Col xs={24} sm={12} md={12} lg={12} xl={12} >
          <Card className="mb30 card-section custom-section mr10" style={{ height: "100%" }}>
            <div className="spaceFlex">
              <h3 style={{ fontSize: 16, marginBottom: 16, color: "#414957" }}>Debt Proforma Impact</h3>
              <Tooltip title={`What is Debt Proforma Impact?`}>
                <QuestionCircleOutlined />
              </Tooltip>
            </div>

            <BarChart
              layout="vertical"
              width={350}
              height={100}
              data={barData}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              barCategoryGap={0}
              barGap={0}
            >
              <XAxis type="number" domain={[0, 50]} hide />
              <YAxis type="category" dataKey="name" width={100} />
              {/* <Tooltip content={<CustomTooltip />} /> */}
              <Bar stackId="a" dataKey="value" barSize={30}>
                {
                  barData && barData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color || '#00FFE0'} />
                  ))
                }
                <LabelList
                  dataKey="value"
                  position="right"
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar>
              {/* <Bar dataKey="safeLimit" stackId="a" barSize={20} fill="#00FFE0">
              <LabelList
                dataKey="safeLimit"
                position="right"
                formatter={() => ""}
                style={{ fill: '#000', fontWeight: 600 }}
              />
            </Bar> */}
              <Bar dataKey="proForma" stackId="a" barSize={30} fill="#3B28CC">
                <LabelList
                  dataKey="proForma"
                  position="right"
                  // formatter={(val) =>
                  //   `${val}%`
                  // }
                  formatter={() => ""}
                  style={{ fill: '#000', fontWeight: 600 }}
                />
              </Bar>
            </BarChart>

            <div style={{ fontSize: 14, lineHeight: '1.6', marginTop: 16 }}>
              {[
                // { label: 'Safe Limit', value: assesmentInfo?.SafeLimit, color: '#00FFE0' },
                { label: 'Current', value: assesmentInfo?.Current, color: '#93C5FD' },
                { label: 'Pro-Forma', value: assesmentInfo?.PostLoan, color: '#3B28CC' },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginBottom: 4,
                    alignItems: 'center'
                  }}
                >
                  <span className="mw80 spanColor">
                    <span style={{ color: item.color, marginRight: 6 }}>■</span>
                    {item.label}
                  </span>
                  <span>{item.value ?? 'N/A'}</span>
                </div>
              ))}
            </div>


            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <div style={{ display: 'inline-grid', textAlign: 'left', fontSize: 14, lineHeight: '1.6' }}>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Total Debt Service ($)
                </span>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Debt-to-Income Ratio (%)
                </span>
              </div>
            </div>

          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Card

            className="card-section custom-section mb30 h100"
            
          >
            <span>Total Debt Service</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalDebtService ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalDebtService)}` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            <span>Total Existing Debt</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalExistingDebt ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalExistingDebt)}` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            <span>Total Income</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalIncome ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalIncome)}` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            <span>Total Assets</span><span className="fRight">{assesmentInfo && assesmentInfo.AssetsValuation ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.AssetsValuation)}` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            <span>Net Worth</span><span className="fRight">{assesmentInfo && assesmentInfo.NetWorth ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.NetWorth)}` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            <span>Debt-to-Income Ratio</span><span className="fRight">{assesmentInfo && assesmentInfo.DebtIncomeRatio ? `${assesmentInfo.DebtIncomeRatio} %` : "N/A"}</span>
            <Divider style={{ margin: "8px 0" }} />
            {/* <span>Number Of Open Accounts</span><span className="fRight">{assesmentInfo && assesmentInfo.NumberOfOpenAccount ? assesmentInfo.NumberOfOpenAccount : "N/A"}</span> */}
            {/* <Divider style={{ margin: "8px 0" }} /> */}
            {/* <span>Hard Inquiries (12 Months)</span><span className="fRight">{assesmentInfo && assesmentInfo.HardEnquiry ? assesmentInfo.HardEnquiry : "N/A"}</span>
          <Divider style={{ margin: "8px 0" }} />
          <span>Bankruptcy/Liens</span><span className="fRight">{assesmentInfo && assesmentInfo.Bankruptcy ? assesmentInfo.Bankruptcy : "N/A"}</span> */}
          </Card>
        </Col>
      </Row>

      <Card className="mb30 card-section custom-section mt30"
        title={
          <Row className="iconFont" align="middle" justify="space-between">
            <Text strong style={{ paddingTop: 0, marginLeft: "15px" }}> <FileTextOutlined /> Credit Facility Details</Text>
            {/* <Tooltip title="What is Loan Program Details?">
              <QuestionCircleOutlined className="ml10" />
            </Tooltip> */}
          </Row>
        }
      >
        <div className="alignment-padding">
          <Row gutter={32}>
            <Col span={12}>
              <div style={{ marginBottom: 12, marginLeft: "15px" }}>
                <Text type="secondary">Requested Loan Amount:</Text><br />
                <span>$ {assesmentInfo?.applicantionRiskFreeLoan?.LoanAmount ? _commonService.formatNumberWithCommas(assesmentInfo.applicantionRiskFreeLoan.LoanAmount) : "N/A"}</span>
              </div>
              <div style={{ marginLeft: "15px" }}>
                <Text type="secondary">Interest Rate:</Text><br />
                <span>{assesmentInfo?.applicantionRiskFreeLoan?.IntrestRate ? `${assesmentInfo.applicantionRiskFreeLoan.IntrestRate} %` : "N/A"}</span>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 12, marginLeft: "50px" }}>
                <Text type="secondary">Advance Rate:</Text><br />
                <span>{assesmentInfo?.applicantionRiskFreeLoan?.Advancerate ? `${assesmentInfo.applicantionRiskFreeLoan.Advancerate} %` : "N/A"}</span>
              </div>
              <div style={{ marginBottom: 12, marginLeft: "50px" }}>
                <Text type="secondary">Projected Interest Expense:</Text><br />
                <span>$ {assesmentInfo?.applicantionRiskFreeLoan?.ProjectedAnnualInterestExpense ? _commonService.formatNumberWithCommas(assesmentInfo.applicantionRiskFreeLoan.ProjectedAnnualInterestExpense) : "N/A"}</span>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </Spin>
  )
};

export default AssessmentTab;